import { UseFormReturn } from 'react-hook-form';
import { UpdateArrearsForm } from 'Feature/Arrears/components/ArrearsInquiryPage/ui/flyout/ArrearsFlyoutContent';
import { Arrears } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Arrears';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import Body from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/Body';
import { AmountFormField } from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/form/AmountFormField';
import { TextFormFieldError } from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/form/TextFormFieldError';
import React from 'react';

export const ArrearsFlyoutAmountField = ({
  label,
  isReadOnly = true,
  form,
  arrears
}: {
  label: string;
  isReadOnly?: boolean;
  form: UseFormReturn<UpdateArrearsForm>;
  arrears: Arrears;
}) => {
  const { t } = useTranslation('HbtArrearsInquiryPage');

  const maximumArrearsAmount =
    arrears.loanAmount === undefined || arrears.loanPremiumAmount === undefined
      ? undefined
      : arrears.loanAmount + arrears.loanPremiumAmount + 400;

  const field = form.register('amount', {
    valueAsNumber: true,
    required: t('arrearsFlyout.errors.amount.required'),
    min: { value: 0.01, message: t('arrearsFlyout.errors.amount.minimum') },
    max:
      maximumArrearsAmount === undefined
        ? undefined
        : { value: maximumArrearsAmount, message: t('arrearsFlyout.errors.amount.maximum') }
  });

  return (
    <Box display="flex" flexDirection="column" gap="8px" flex="1">
      <Body size={'smallBold'}>{label}</Body>
      <AmountFormField
        defaultValue={form.getValues(field.name)}
        onChange={async (e) => await field.onChange(e)}
        onValueChange={(v) => form.setValue(field.name, v)}
        name={field.name}
        disabled={isReadOnly}
        inputRef={field.ref}
        inputProps={{
          'aria-label': label
        }}
        error={!!form.formState.errors.amount}
        helperText={<TextFormFieldError error={form.formState.errors.amount?.message} />}
        showClearButton={
          !(Number.isNaN(form.getValues(field.name)) || form.getValues(field.name) === undefined)
        }
        onClear={async () => {
          form.setValue(field.name, undefined, { shouldValidate: true });
        }}
      />
    </Box>
  );
};
